import React from 'react';
import { useSearchParams } from 'react-router-dom';

import ProgramDetail from './ProgramDetail';
import ProgramList, { useProgramListState } from './ProgramList';

/**
 * Programs: the list, or one program when the URL carries ?id=. The list's
 * search, filters, page and sort live here so they survive a visit to a
 * program; the detail is keyed by id so no half-finished edit follows you
 * from one program to the next.
 */
const OpsPrograms: React.FC = () => {
  const [searchParams] = useSearchParams();
  const programId = searchParams.get('id') ?? '';
  const list = useProgramListState();
  return programId ? (
    <ProgramDetail key={programId} programId={programId} sort={list} />
  ) : (
    <ProgramList state={list} />
  );
};

export default OpsPrograms;
